import { Component, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';
import { ToastrService } from 'ngx-toastr';
import { AES } from 'crypto-js';
import { GlobalTicketService } from '@services/global-ticket-service.service';
import { formatPedidoFolio } from '@/utils/pedido-folio';

@Component({
  selector: 'app-ticket-global',
  templateUrl: './ticket-global.component.html',
  styleUrls: ['./ticket-global.component.scss']
})
export class TicketGlobalComponent {
  @ViewChild('content') content!: TemplateRef<any>;
  base64: any;
  Pedido: any;

  constructor(
    private globalTicket: GlobalTicketService,
    private toastr: ToastrService,
    public generalService: GeneralService,
    protected sanitizer: DomSanitizer,
    public loadingService: LoadingService
  ) {}

  async open(idPedido: number) {
    await this.getPedido(idPedido);
    await this.getTicket(idPedido);
    this.globalTicket.open(this.content, idPedido);
  }

  async getTicket(idPedido: number) {
    if (!idPedido) return;
    this.loadingService.setLoading(true);
    try {
      const res: any = await this.generalService.getObtiene("documentos/ticket", idPedido);
      this.base64 = this.sanitizer.bypassSecurityTrustResourceUrl(res.data.base64);
    } catch (err) {
      console.error(err);
    } finally {
      this.loadingService.setLoading(false);
    }
  }

  async getPedido(idPedido: number) {
    try {
      const res: any = await this.generalService.getObtiene("pedido", idPedido);
      this.Pedido = res.data;
    } catch (error) {
      this.Pedido = null;
    }
  }

  closeModal() {
    this.globalTicket.close();
  }

  enviarWsp() {
    if (!this.Pedido?.cliente?.telefono) return;
    const clave = 'V0ugwk04DfHD7';
    const parametroEncriptado = AES.encrypt(`idPedido:${this.Pedido.id_pedido}`, clave).toString();
    const parametroCodificado = encodeURIComponent(parametroEncriptado.replace(/\//g, '_'));
    const link = `${window.location.protocol}//${window.location.hostname}/detalle/${parametroCodificado}`;
    const folio = formatPedidoFolio(this.Pedido);
    const mensaje = `${this.Pedido.cliente.nombre_completo}, se ha generado el pedido ${folio}, haz click aquí: ${link}`;
    window.open(`https://api.whatsapp.com/send?phone=${this.Pedido.cliente.telefono.replace(/[+]/g, '')}&text=${mensaje}`, '_blank');
  }

  enviarMail() {
    if (!this.Pedido?.cliente?.email) return;
    this.loadingService.setLoading(true);
    const clave = 'V0ugwk04DfHD7';
    const parametroEncriptado = AES.encrypt(`idPedido:${this.Pedido.id_pedido}`, clave).toString();
    const parametroCodificado = encodeURIComponent(parametroEncriptado.replace(/\//g, '_'));
    const link = `${window.location.protocol}//${window.location.hostname}/detalle/${parametroCodificado}`;
    const folio = formatPedidoFolio(this.Pedido);
    const body = {
      to: this.Pedido.cliente.email,
      subject: `Creacion Ticket ${folio}`,
      nombre_cliente: this.Pedido.cliente.nombre_completo,
      id_pedido: folio,
      url_ticket: link
    };
    this.generalService.postCrear("mail/sendTicket", body)
      .then(() => this.toastr.success('Correo enviado exitosamente!'))
      .catch(() => this.toastr.error('Error al enviar correo!'))
      .finally(() => this.loadingService.setLoading(false));
  }
}
